import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.6875 0.407227C8.76562 0.329102 8.88281 0.290039 9.03906 0.290039C9.15625 0.290039 9.27344 0.329102 9.35156 0.407227L17.5938 8.68848C17.6719 8.7666 17.75 8.88379 17.75 9.00098C17.75 9.15723 17.6719 9.23535 17.5938 9.31348L9.35156 17.5947C9.27344 17.6729 9.15625 17.7119 9.03906 17.7119C8.88281 17.7119 8.76562 17.6729 8.6875 17.5947L8.41406 17.2822C8.33594 17.2041 8.29688 17.126 8.29688 16.9697C8.29688 16.8525 8.33594 16.7354 8.41406 16.6182L15.4062 9.66504H0.71875C0.5625 9.66504 0.445312 9.62598 0.367188 9.54785C0.289062 9.46973 0.25 9.35254 0.25 9.19629V8.80566C0.25 8.68848 0.289062 8.57129 0.367188 8.49316C0.445312 8.41504 0.5625 8.33691 0.71875 8.33691H15.4062L8.41406 1.38379C8.33594 1.30566 8.29688 1.18848 8.29688 1.03223C8.29688 0.915039 8.33594 0.797852 8.41406 0.719727L8.6875 0.407227Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
